/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../Layout/Layout";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Constants from "../../../common/SupplierConstants";
import { getBudgetList, deleteBudget } from "../../../redux/feature/supplier_app/budgetSlice";
import toast from "react-hot-toast";
import { SearchField } from "../../../Components/formElements/SearchField";

const BudgetList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Admin");
  localStorage.setItem("submenu", "Budget");

  const budgetList = useSelector((state) => state?.budget?.data);
  const budgetPagination = useSelector((state) => state?.budget?.pagination);
  const isLoading = useSelector((state) => state?.budget?.status);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [getPage, setPage] = useState(1);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [disabled, setDisabled] = useState(false);

  const loadBudgetList = () => {
    dispatch(
      getBudgetList({
        page: getPage,
        per_page: getNewPerPage,
        searchTerm: getCommonSearchTxt,
      })
    );
  };

  useEffect(() => {
    loadBudgetList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPage, getNewPerPage]);

  const handleSearchFuncApi = () => {
    setPage(1);
    dispatch(
      getBudgetList({
        page: 1,
        per_page: getNewPerPage,
        searchTerm: getCommonSearchTxt,
      })
    );
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setNewPerPage(newPerPage);
    setPage(page);
  };

  const navigateCreateBudget = () => {
    navigate(Constants.BUDGET_CREATE);
  };

  const handleView = (row) => {
    navigate(Constants.BUDGET_DETAILS, { state: { budgetId: row._id } });
  };

  const handleEdit = (row) => {
    navigate(Constants.BUDGET_CREATE, { state: { budgetId: row._id } });
  };

  const handleDelete = async (row) => {
    if (
      !window.confirm(
        `Are you sure you want to delete Budget - ${row.documentNumber || row.budgetName}?`
      )
    ) {
      return;
    }
    setDisabled(true);
    await dispatch(deleteBudget({ _id: row._id }))
      .unwrap()
      .then((item) => {
        if (item?.status === 200) {
          toast.success(item?.message || "Budget deleted successfully");
          loadBudgetList();
        } else {
          toast.error(item?.message || "!! Unable to delete Budget");
        }
      })
      .catch(() => {
        toast.error("!! Unable to delete Budget");
      });
    setDisabled(false);
  };

  const formatAmount = (amount, currency) => {
    let num = Number(amount || 0);
    return (currency || "INR") + " " + num.toLocaleString("en-IN");
  };

  const userListColInfo = [
    {
      name: "Budget No",
      selector: (row) => row.documentNumber,
      sortable: true,
      cell: (row) => (
        <button className="btnInfo" onClick={() => handleView(row)}>
          {row.documentNumber || "--"}
        </button>
      ),
      width: "130px",
    },
    {
      name: "Budget Name",
      selector: (row) => row.budgetName,
      sortable: true,
      cell: (row) => <span className="fw-bold">{row.budgetName || "--"}</span>,
      width: "180px",
    },
    {
      name: "Company",
      selector: (row) => row.company,
      sortable: true,
      cell: (row) => <>{row.company || "--"}</>,
      width: "160px",
    },
    {
      name: "Category",
      selector: (row) => row.category,
      sortable: true,
      cell: (row) => <>{row.category || "--"}</>,
      width: "160px",
    },
    {
      name: "Department",
      selector: (row) => row.department,
      sortable: true,
      cell: (row) => <>{row.department || "--"}</>,
      width: "140px",
    },
    {
      name: "Financial Year",
      selector: (row) => row.financialYear,
      sortable: true,
      cell: (row) => <>{row.financialYear || "--"}</>,
      width: "120px",
    },
    {
      name: "Budget Amount",
      selector: (row) => row.budgetAmount,
      sortable: true,
      cell: (row) => (
        <span className="fw-bold">{formatAmount(row.budgetAmount, row.currency)}</span>
      ),
      width: "160px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <span
          className={`badge ${
            row.status === "Active" || row.status === "Approved"
              ? "bg-success"
              : row.status === "Rejected"
              ? "bg-danger"
              : "bg-secondary"
          }`}
        >
          {row.status || "Draft"}
        </span>
      ),
      width: "110px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex gap-1">
          <button
            className="btnTable"
            title="View Details"
            onClick={() => handleView(row)}
          >
            <i className="bi bi-eye"></i>
          </button>
          <button
            className="btnTable"
            title="Edit"
            onClick={() => handleEdit(row)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button
            className="btnTable"
            title="Delete"
            disabled={disabled}
            onClick={() => handleDelete(row)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "140px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={8} md={10} lg={10} className="mb-2">
                <h2 className="mainTitle">Budget List</h2>
                <p className="subText">Budget Creation Details</p>
              </Col>
              <Col
                xs={4}
                md={2}
                lg={2}
                className="mb-2 d-flex justify-content-end align-items-center"
              >
                <button className="btn" onClick={navigateCreateBudget}>
                  Create
                </button>
              </Col>
              <hr />
            </Row>

            {/* budget list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BD</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">List Of Budget</span>
                    </Col>
                    <Col xs={2} md={7} lg={7} className="d-flex justify-content-end">
                      <SearchField
                        name="searchKey"
                        placeholder="Search by Budget No / Name / Company / Category"
                        value={getCommonSearchTxt}
                        onChange={(e) => setCommonSearchTxt(e.target.value)}
                        onClick={() => handleSearchFuncApi()}
                      />
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={userListColInfo}
                          data={budgetList || []}
                          progressPending={isLoading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={budgetPagination?.total || 0}
                          paginationDefaultPage={getPage}
                          paginationPerPage={getNewPerPage}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          highlightOnHover
                          pointerOnHover
                          noDataComponent={
                            <div className="noDataMsg">No Budgets Found</div>
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default BudgetList;
